if(typeof table_controller == 'undefined'){
    var table_controller = {
        selector: '.table-column',
        inner_selector: '.flex-table',
        resize: function(){
            var $columns = jQuery(table_controller.selector);
            $columns.each(function(i){
                var issue = table_controller.detect(this);
                if(
                    issue
                    && !jQuery(this).hasClass('table-overflow')
                ){
                    table_controller.init_mobile(this);
                }else if(
                    !issue
                    && jQuery(this).hasClass('table-overflow')
                ){
                    table_controller.remove_mobile(this);
                }
                    
            });
        },
        init_mobile: function(dom){
            var $this = jQuery(dom);
            var id = $this.attr('id');
            var width = $this.width();
            var table_width = $this.find(table_controller.inner_selector).width();
            var to_insert = '<div class="dummy-scroll" for="'+id+'" style="width:100%;overflow:auto;"><div class="scroll-inner" style="width:'+table_width+'px"></div></div>';
            if($this.parent().find('.dummy-scroll').length > 0){
                var $to_insert = jQuery(to_insert);
                $to_insert.scroll(function(){
                    var $this = jQuery(this);
                    var id = $this.attr('for');
                    var $table_column = jQuery('#'+id);
                    $table_column.scrollLeft($this.scrollLeft());
                });
                $this.scroll(function(){
                    var $this = jQuery(this);
                    var id = $this.attr('id');
                    var $dummy = jQuery('.dummy-scroll[for="'+id+'"]');
                    $dummy.scrollLeft($this.scrollLeft());
                    table_controller.addShadows($this);
                });
                $this.before($to_insert);
            }
            table_controller.addShadows($this[0]);
        },
        addShadows: function(dom){
            var $this = jQuery(dom);
            var scrollWidth = $this[0].scrollWidth;
            var width = $this.width();
            var scrollLeft = $this.scrollLeft();
            if(
                scrollLeft > 0
                && !$this.hasClass('shadow-left')
            ){
                $this.addClass('shadow-left');
            }else if(scrollLeft == 0){
                $this.removeClass('shadow-left');
            }

            if(
                scrollWidth - width > scrollLeft
                && !$this.hasClass('shadow-right')
            ){
                $this.addClass('shadow-right');
            }else if(scrollWidth - width <= scrollLeft){
                $this.removeClass('shadow-right');
            }
        },
        remove_mobile: function(dom){
            var $this = jQuery(dom);
            var id = $this.attr('id');
            var $dummy = jQuery('.dummy-scroll[for="'+id+'"]');
            $dummy.remove();
            $this.off('scroll');
        },
        detect: function(dom){
            var $this = jQuery(dom);
            $table = $this.find(table_controller.inner_selector);
            if($this.width() < $table.width()){
                return true;
            }
            return false;
        },
        init: function(){
            var $columns = jQuery(table_controller.selector);
            if($columns.length > 0){
                table_controller.resize();
                jQuery(window).resize(function(){
                    table_controller.resize();
                });
            }
        }
    };

    jQuery(document).ready(function(){
        table_controller.init();
    });
}